import {
  FDAccordion,
  FDAccordionDetails,
  FDAccordionTitle,
  FDPaper,
  FDStack,
  FDTitleText,
  FDIcon,
  FDBodyText,
  FDLabelText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';

// TODO: Fast Follow, refactor to use FDStat once it works properly with flex
function ScenarioSelectionStat({ label, value }) {
  return (
    <FDStack direction={'column'}>
      <FDLabelText value={label} size={'lg'} color={'textPrimary'} />
      <FDLabelText value={value} size={'lg'} color={'textSecondary'} />
    </FDStack>
  );
}

ScenarioSelectionStat.defaultProps = {
};

ScenarioSelectionStat.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default function ScenarioOutcomeTimelineCard({ resource, expanded }) {
  const isMobile = useMobileLayout();
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(expanded || false);

  const detailValueItems = resource.attr('detailValues').resources().list();

  const renderDetailValues = (detailValues) => {
    return detailValues
      .map((item) => {
        return (
          <FDStack direction={'column'} spacing={1} flex={1} key={item.id()} {...dataAttrs('scenario-outcome-timeline-card-stat')}>
            <FDIcon color={item.attr('iconColor')} icon={item.attr('icon')} size={'sm'} />
            <ScenarioSelectionStat label={item.meta().field('value').attr('prompt')} value={item.attr('value')} />
            <FDBodyText value={item.attr('description')} size={'sm'} align={'start'} />
          </FDStack>
        );
      });
  };

  return (
    <FDPaper appearance={'elevated'} {...dataAttrs('scenario-outcome-timeline-card', resource)} width={'100%'}>
      <FDAccordion expanded={isAccordionExpanded} onChange={() => setIsAccordionExpanded(!isAccordionExpanded)}>
        <FDAccordionTitle>
          <FDStack direction={'row'} spacing={2} padding={1} wrap flex={1} alignItems={'center'} justifyContent={'space-between'}>
            <FDStack direction={'row'} spacing={1} alignItems={'center'}>
              <FDIcon color={resource.attr('iconColor')} icon={resource.attr('icon')} />
              <FDTitleText size={'lg'} value={resource.attr('title')} />
            </FDStack>
          </FDStack>
        </FDAccordionTitle>
        <FDAccordionDetails>
          <FDStack direction={isMobile ? 'column' : 'row'} spacing={6} padding={3}>
            {renderDetailValues(detailValueItems)}
          </FDStack>
        </FDAccordionDetails>
      </FDAccordion>
    </FDPaper>
  );
}

ScenarioOutcomeTimelineCard.defaultProps = {
  expanded: false,
};

ScenarioOutcomeTimelineCard.propTypes = {
  resource: PropTypes.object.isRequired,
  expanded: PropTypes.bool,
};
